module.exports = __webpack_public_path__ + "img/yida.e94f21c0.jpg";